export enum BackCardCollectionType {
    BASICS = 'Basics',
    STARCARDS = 'StarCards',
    PARIS = 'Paris',
    BALI = 'Bali',
    ITALY = 'Italy',
    JAPAN = 'Japan',
    ICELAND = 'Iceland',
    AUSTRALIA = 'Australia',
    EGIPTY = 'Egypt',
    ARIZONA = 'Arizona',
    AUSTRIA = 'Austria',
    TANZANIA = 'Tanzania',
    BERLIN = 'Berlin',
    CAMBODIA = 'Cambodia',
    ENGLAND = 'England',
    CANADA = 'Canada',
    BRAZIL = 'Brazil',
    RUSSIA = 'Russia',
    CALIFORNIA = 'California',
    POLAND = 'Poland',
    ARGENTINA = 'Argentina',
    TURKEY = 'Turkey',
    GREECE = 'Greece',
    CUBA = 'Cuba',
    SPAIN = 'Spain',
    KOREA = 'Korea',
    UKRAINE = 'Ukraine',
    CHILE = 'Chile',
    INDIA = 'India',
}

export const SortedBackCardCollections: BackCardCollectionType[] = [
    BackCardCollectionType.BASICS,
    BackCardCollectionType.STARCARDS,
    BackCardCollectionType.AUSTRIA,
    BackCardCollectionType.BALI,
    BackCardCollectionType.ITALY,
    BackCardCollectionType.JAPAN,
    BackCardCollectionType.ICELAND,
    BackCardCollectionType.AUSTRALIA,
    BackCardCollectionType.EGIPTY,
    BackCardCollectionType.ARIZONA,
    BackCardCollectionType.PARIS,
    BackCardCollectionType.TANZANIA,
    BackCardCollectionType.BERLIN,
    BackCardCollectionType.CAMBODIA,
    BackCardCollectionType.ENGLAND,
    BackCardCollectionType.CANADA,
    BackCardCollectionType.BRAZIL,
    BackCardCollectionType.RUSSIA,
    BackCardCollectionType.CALIFORNIA,
    BackCardCollectionType.POLAND,
    BackCardCollectionType.ARGENTINA,
    BackCardCollectionType.TURKEY,
    BackCardCollectionType.GREECE,
    BackCardCollectionType.CUBA,
    BackCardCollectionType.SPAIN,
    BackCardCollectionType.KOREA,
    BackCardCollectionType.UKRAINE,
    BackCardCollectionType.CHILE,
    BackCardCollectionType.INDIA,
];
